<template>
  <div v-if="media" class="row pt-2">
    <div v-for="(medium, key) in media" :key="key" class="position-relative">
      <div v-if="medium" class="media-container no-edit">
        <div class="d-flex align-items-center justify-content-center border position-relative media-element">
          <img v-if="medium.preview_url" :src="medium.preview_url" :title="medium.name" class="border mh-100 mw-100" />
          <span
            v-if="!medium.preview_url && medium.collection_name.substring(0, 9) !== 'temporary'"
            class="w-100 text-center position-absolute"
          >
            <i class="bi bi-dash-circle text-warning" style="font-size: 4rem"></i>
          </span>
        </div>
        <a :href="medium.original_url" class="d-block border border-top-0 p-2 text-truncate" target="_blank">
          <i class="bi bi-paperclip"></i>
          <span>{{ medium.name }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    media: { type: Object, default: () => {} },
  },
  setup() {},
};
</script>
